import styled from 'styled-components'
import { transitions } from 'polished'
import theme from 'styles/theme'
import { Body12 } from 'components/Typography'
import { Box } from 'rebass'

export const Wrapper = styled(Box)`
  width: 100%;
  text-align: center;
  background-color: ${(props) =>
    props.greyBackground
      ? props.theme.colors.backgroundColor
      : props.theme.colors.backgroundColor};
`

export const ItemList = styled.dl`
  align-items: flex-start;
  color: ${(props) =>
    props.greyBackground
      ? props.theme.colors.sagedark
      : props.theme.colors.sagedark};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 0;
  margin-top: 10px;

  ${theme.mediaQueries.medium} {
    display: flex;
    margin-top: 50px;
  }

  a {
    ${transitions('border-color ease-in 0.2s')};

    border-bottom: 1px solid transparent;
    text-decoration: none;

    &:hover,
    &:focus {
      border-color: currentColor;
    }
  }
`

export const Item = styled.div`
  padding: ${theme.space[1]};
  display: flex;
  flex-direction: column;
  width: 100%;

  dt {
    display: block;
    padding-left: ${theme.space[1]};

    ${theme.mediaQueries.medium} {
      display: inline-block;
      margin: 0;
    }
  }

  dd {
    display: block;
    margin: 0;
    padding: 5px 0;
    text-align: left;
    white-space: nowrap;

    ${theme.mediaQueries.medium} {
      display: inline-block;
      margin: 0 ${theme.space[1]};
    }
  }

  ${theme.mediaQueries.medium} {
    width: calc(100% / 4);
  }
`

export const ButtonWrapper = styled.div`
  margin-top: ${theme.space[3]};
  text-align: center;

  ${theme.mediaQueries.medium} {
    margin-top: ${theme.space[10]};
  }

  a > span {
    margin-top: 5px;
  }

  a {
    width: 100%;

    ${theme.mediaQueries.small} {
      width: auto;
    }
  }
`

export const Header = styled.h2`
  color: ${(props) =>
    props.greyBackground
      ? props.theme.colors.sagedarkToblack
      : props.theme.colors.sagedarkToblack};
`

export const ContactHeader = styled.h2`
  color: ${(props) =>
    props.greyBackground
      ? props.theme.colors.sagedarkToblack
      : props.theme.colors.sagedarkToblack};
`

export const Logo = styled(Box)`
  margin: ${theme.space[2]} 0;
`

export const ContactLogo = styled(Box)`
  max-height: 32px;
`

export const AddressText = styled(Body12)`
  white-space: pre-wrap;
`

export const ContactTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid
    ${(props) =>
      props.greyBackground
        ? props.theme.colors.sagedarkToblack
        : props.theme.colors.sagedarkToblack};
  padding-bottom: 5px;
`

export const ContactContainer = styled.div`
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: flex-start;
  padding-left: ${theme.space[1]};
  padding-top: ${theme.space[2]};

  ${theme.mediaQueries.smallOnly} {
    padding-bottom: ${theme.space[2]};
  }
`

export const DirectionContainer = styled.div`
  padding: ${theme.space[4]} 0;
`

export const ContactDetailsContainer = styled.div`
  padding: ${theme.space[4]} 0;
`
